export default __webpack_public_path__ + "static/media/woman-with-guitar.97e669f6.png";